/// <amd-module name="TFS/Admin/Common/Controls/DeleteMultiDialog/DeleteMultiDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { Link } from "VSSUI/Link";
import { IVssPageContext } from "VSS/Platform/Context";
import { TextField } from "VSSUI/TextField";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { KeyCode } from "VSSUI/Util";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { ObservableValue } from "VSS/Core/Observable";
import { VssComponent } from "VSS/Platform/Layout";
import * as AdminResources from "TFS/Admin/Common/Controls/Resources";
import { ContentSize } from "VSSUI/Callout";
import { IDeleteMultiDialogProps } from "TFS/Admin/Common/Controls/DeleteMultiDialog/DeleteMultiDialog.Props";

interface IDeleteMultiDialogState {
    isMatch: boolean;
    hasClicked: boolean;
}

export class DeleteMultiDialog extends React.Component<IDeleteMultiDialogProps, IDeleteMultiDialogState> {
    private inputConfirmText = new ObservableValue<string>("");
    private projectList: string;
    private projectCount: number;
    private noPermisionList: string;
    private noPermisionCount: number;
    constructor(props: IDeleteMultiDialogProps) {
        super(props);
        this.state = {
            isMatch: false,
            hasClicked: false
        };
        this.projectList = this.props.projectNames.join(", ");
        this.projectCount = this.props.projectNames.length;
        this.noPermisionList = this.props.noPermissionProjectNames.join(", ");
        this.noPermisionCount = this.props.noPermissionProjectNames.length;
    }

    public render(): JSX.Element {
        return (
            <Dialog
                calloutClassName="delete-multi-project-dialog"
                titleProps={{ text: this.projectCount > 1 ? AdminResources.DeleteMultiProjectDialogTitle : AdminResources.DeleteProjectDialogTitle }}
                onDismiss={() => this.props.onCancel()}
                contentSize={ContentSize.Large}
                footerButtonProps={[
                    { text: AdminResources.Cancel, onClick: this.props.onCancel },
                    {
                        className: "delete-project-button",
                        danger: true,
                        disabled: !this.state.isMatch,
                        onClick: this.props.onDeleteProject,
                        text: AdminResources.DeleteButton
                    }
                ]}
            >
                <div>
                    {this.noPermisionCount > 0 && (
                        <div className="delete-project-error-paragraph">
                            <FormatComponent format={AdminResources.DeleteMultiProjectErrorProjects} className="project-list">
                                <span className="fontWeightSemiBold">{this.noPermisionList}</span>
                            </FormatComponent>
                        </div>
                    )}

                    {this.projectCount > 0 && (
                        <>
                            <div className="delete-project-first-paragraph">
                                <FormatComponent format={AdminResources.DeleteMultiProjectFirstParagraph} className="project-list">
                                    <span className="fontWeightSemiBold">{this.projectList}</span>
                                </FormatComponent>
                            </div>
                            <div className="delete-project-second-paragraph">
                                {this.projectCount > 1 ? (
                                    <FormatComponent format={AdminResources.DeleteMultiProjectSecondParagraph}>
                                        <span className="delete-project-name fontWeightSemiBold">{this.projectCount}</span>
                                    </FormatComponent>
                                ) : (
                                    AdminResources.DeleteProjectSecondParagraph
                                )}
                                <Link
                                    className="learn-more-link"
                                    href={AdminResources.DeleteMultiProjectLearnMoreLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={AdminResources.DeleteMultiProjectLearnMoreAriaLabel}
                                >
                                    {AdminResources.DeleteMultiProjectLearnMoreAriaLabel}
                                </Link>
                            </div>
                            <div id="delete-projects" className="delete-project-action-paragraph">
                                <FormatComponent format={AdminResources.DeleteMultiProjectConfirmationText}>
                                    {this.projectCount > 1 ? (
                                        <span className="delete-project-name fontWeightSemiBold">{AdminResources.ConfirmMessage}</span>
                                    ) : (
                                        <span className="delete-project-name fontWeightSemiBold">{this.props.projectNames[0]}</span>
                                    )}
                                </FormatComponent>
                            </div>
                            <TextField
                                className="org-name-text-field-margin"
                                onKeyDown={this._onKeyPress}
                                placeholder={this.projectCount > 1 ? AdminResources.DeleteMultiProjectPlaceholderText : AdminResources.DeleteSingleProjectPlaceholderText}
                                onChange={this._onNameChanged}
                                disabled={this.projectCount == 0}
                                value={this.inputConfirmText}
                                ariaLabelledBy="delete-projects"
                            />
                        </>
                    )}
                </div>
            </Dialog>
        );
    }

    private _onNameChanged = (event: any, value: string) => {
        this.inputConfirmText.value = value;
        this._validateProjectName(value);
    };

    //event.keycode returns zero so using which instead
    private _onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.which === KeyCode.enter && this.state.isMatch) {
            this.props.onDeleteProject();
        }
    };

    private _validateProjectName = (name: string): void => {
        if ((this.projectCount == 1 && !localeIgnoreCaseComparer(name, this.props.projectNames[0])) || (this.projectCount > 1 && !localeIgnoreCaseComparer(name, AdminResources.ConfirmMessage))) {
            this.setState({ isMatch: true });
        } else {
            this.setState({ isMatch: false });
        }
        return undefined;
    };
}

VssComponent.register("ms.vss-admin-web.delete-multi-dialog", DeleteMultiDialog);
